// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"120fa44b","629":"c7d23443"}[chunkId] + ".chunk.js";
};